const documentsPage = {
  searchDocuments: "חיפוש מסמך...",
  refresh: "רענן",
  newDocument: "מסמך חדש",
  noDocuments: "אין מסמכים",
  total: "סה\"כ",
  currentlyViewing: "צופים עכשיו",
  signed: "חתמו",
  expired: "פג תוקף",
  now: "עכשיו",
  minutesAgo: "לפני {n} דק׳",
  hoursAgo: "לפני {n} שע׳",
  daysAgo: "לפני {n} ימים",
  draft: "טיוטה",
  sent: "נשלח",
  viewed: "נצפה",
  partiallySigned: "חתום חלקי",
  signedStatus: "חתום",
  archived: "ארכיון",
  analytics: "אנליטיקס",
  completionRate: "שיעור השלמה",
  completed: "הושלמו",
  pending: "ממתין",
  signerProgress: "התקדמות חותמים",
  signersSigned: "חתמו",
  avgSignTime: "זמן חתימה ממוצע",
  documentsAnalyzed: "מסמכים",
  expiringSoon: "פג תוקף בקרוב",
  within7Days: "בתוך 7 ימים",
  needsAttention: "דורש טיפול",
} as const;
export default documentsPage;
